"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DAY_CACHE_PERIOD = exports.HOUR_CACHE_PERIOD = exports.MINUTE_CACHE_PERIOD = void 0;
var MINUTE_CACHE_PERIOD = 60;
exports.MINUTE_CACHE_PERIOD = MINUTE_CACHE_PERIOD;
var HOUR_CACHE_PERIOD = 60 * MINUTE_CACHE_PERIOD;
exports.HOUR_CACHE_PERIOD = HOUR_CACHE_PERIOD;
var DAY_CACHE_PERIOD = 24 * HOUR_CACHE_PERIOD;
exports.DAY_CACHE_PERIOD = DAY_CACHE_PERIOD;